import { useState } from 'react';
import {
  Box,
  Rating,
} from '@mui/material';
import { StarRounded } from '@mui/icons-material';

const labels = {
  1: 'Useless',
  2: 'Poor',
  3: 'Ok',
  4: 'Good',
  5: 'Excellent',
};

const HoverRating = ({ rating, setRating, showRatingDescription }) => {
  const [hover, setHover] = useState(-1);
  return (
    <Box
      sx={{
        width: 200,
        display: 'flex',
        alignItems: 'center',
      }}
    > 
      <Rating
        name="feedback-rating"
        value={rating}
        precision={1}
        size="large"
        onChange={(event, newValue) => {
          setRating(newValue);
        }}
        onChangeActive={(event, newHover) => {
          setHover(newHover);
        }}
        icon={<StarRounded fontSize="inherit" />}
        emptyIcon={<StarRounded style={{ opacity: 0.55 }} fontSize="inherit" />}
      />
      {
        showRatingDescription && rating !== null && (
          <Box sx={{ ml: 2 }}>
            {labels[hover !== -1 ? hover : rating]}
          </Box>
        )
      }
    </Box>
  );
}

export default HoverRating;